import { makeStyles } from '@material-ui/core/styles';

const colors = {
  headerBackgroundColor: '#DFEFFF',
  headerTextColor: 'rgba(0, 0, 0, 0.89)',
  closeIconColor: '#1F529C',
  headerButtonBorderColor: 'rgba(0, 0, 0, 0.89)',
  headerButtonTextColor: 'rgba(0, 0, 0, 0.89)',
  selectedButtonBackgroundColor: '#9EBEFB',
  selectedButtonTextColor: '#000',
  smsTextColor: 'rgba(0,0,0,0.89)',
  smsRowBorderColor: 'rgba(0,0,0,0.89)',
  smsHighlightedBackgroundColor: '#F8F8F8',
  primaryButtonBackgroundColor: '#0060FF',
  primaryButtonTextColor: '#fff',
  secondaryButtonBorderColor: '#0060FF',
  secondaryButtonTextColor: '#0060FF',
  smsSuccessColor: '#2C774E',
  smsErrorColor: '#B51919',
};

const useStyles = makeStyles((theme) => ({
  dialogTitleContainer: {
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
    backgroundColor: colors.headerBackgroundColor,
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
  },
  dialogContent: {
    padding: theme.spacing(2.5),
  },
  dialogTitle: {
    color: colors.headerTextColor,
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(0.5),
    color: colors.closeIconColor,
  },
  smsSuccess: {
    color: colors.smsSuccessColor,
  },
  smsError: {
    color: colors.smsErrorColor,
  },
  successIcon: {
    color: colors.smsSuccessColor,
  },
  errorIcon: {
    color: colors.smsErrorColor,
  },
  smsSuccessButton: {
    backgroundColor: colors.primaryButtonBackgroundColor,
    color: colors.primaryButtonTextColor,
    width: '120px',
    position: 'absolute',
    bottom: '10px',
    right: '10px'
  },
  smsErrorButton: {
    backgroundColor: colors.smsErrorColor,
    color: colors.primaryButtonTextColor,
    width: '120px',
    position: 'absolute',
    bottom: '10px',
    right: '10px'
  },
  header: {
    marginBottom: theme.spacing(1),
  },
  headerBtn: {
    width: '110px',
    textTransform: 'none',
    color: colors.headerButtonTextColor,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: colors.headerButtonBorderColor,
    "&:hover": {
      borderColor: colors.headerButtonBorderColor,
    }
  },
  selectButtonGrp: {
    backgroundColor: colors.selectedButtonBackgroundColor,
    color: colors.selectedButtonTextColor,
    "&:hover": {
      backgroundColor: colors.selectedButtonBackgroundColor,
    }
  },
  smsRow: {
    borderStyle: 'solid',
    borderWidth: '1px',
    borderColor: colors.smsRowBorderColor,
    padding: theme.spacing(1),
    borderRadius: theme.spacing(0.5),
  },
  highlightedRow: {
    backgroundColor: colors.smsHighlightedBackgroundColor,
  },
  rowContent: {
    color: colors.smsTextColor,
  },
  primaryButton: {
    backgroundColor: colors.primaryButtonBackgroundColor,
    color: colors.primaryButtonTextColor,
    marginLeft: '8px',
    boxShadow: 'none',
    width: '120px',
    '&:hover': {
      backgroundColor: colors.primaryButtonBackgroundColor,
      color: colors.primaryButtonTextColor,
    }
  },
  secondaryButton: {
    borderColor: colors.secondaryButtonBorderColor,
    color: colors.secondaryButtonTextColor,
    boxShadow: 'none',
    width: '120px',
  },
}));

export default useStyles;
